import { motion, AnimatePresence, AnimateSharedLayout } from 'framer-motion';
import { Header } from './header';
import { Footer } from './footer';
import { Panels } from './panels';

import '../styles/app.scss';

export default function Layout({ path, title, children, ...restProps }) {
  return (
    <>
      <Header path={path} />
      <Panels path={path} />
      <AnimatePresence initial={false}>
        <motion.main
          key={path}
          className="main"
          initial={{ visibility: 'hidden' }}
          animate={{ visibility: 'visible', transition: { delay: 1 } }}
          exit={{ visibility: 'hidden', transition: { delay: 1 } }}
          transition={{
            type: 'spring',
            duration: 0.4,
            delay: 0.6,
          }}
        >
          <AnimateSharedLayout>{children}</AnimateSharedLayout>
        </motion.main>
      </AnimatePresence>
      <Footer />
    </>
  );
}
